import type {
  DocumentDataExtractorConfiguration,
  DocumentDataExtractorScreenConfiguration,
  GenericDocument,
  ImageInput,
  ResultWrapper,
} from '../types';
import {
  DocumentDataExtractionResult,
  DocumentDataExtractorUiResult,
  DocumentVerificationReport,
  handleImageInput,
  mapRTUUIResult,
  withSBErrorHandling,
} from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotDocumentDataExtractorImpl = {
  async extractFromImage(params: {
    image: ImageInput;
    configuration: DocumentDataExtractorConfiguration;
  }): Promise<DocumentDataExtractionResult> {
    return withSBErrorHandling(
      async () =>
        new DocumentDataExtractionResult(
          await ScanbotSDKPlugin.extractDocumentDataFromImage({
            configuration: params.configuration,
            image: handleImageInput(params.image),
          }),
        ),
    );
  },

  async startExtractorScreen(
    configuration: DocumentDataExtractorScreenConfiguration,
  ): Promise<ResultWrapper<DocumentDataExtractorUiResult>> {
    return withSBErrorHandling(async () =>
      mapRTUUIResult<DocumentDataExtractorUiResult>(
        await ScanbotSDKPlugin.startDDEScreen(configuration),
        DocumentDataExtractorUiResult,
      ),
    );
  },

  async verifyDocument(documentParts: GenericDocument[]): Promise<DocumentVerificationReport> {
    return withSBErrorHandling(
      async () => new DocumentVerificationReport(await ScanbotSDKPlugin.verifyDocument({ documentParts })),
    );
  },
};
